import appSettings from 'wanderu-config';

async function sendEvents(events) {
    const url = _getUrl();

    const response = await fetch(url, {
        method: 'post',
        body: JSON.stringify(events),
        headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'text/plain',
        },
    });

    if (!response.ok) {
        throw new Error(`Unable to send event to ${url}`);
    }
}

function _getUrl() {
    return `${appSettings.config.wapi.urlRoot}events.json`;
}

export { sendEvents };

export default {
    sendEvents,
};
